import Avatar from '../atoms/Avatar/AvatarTheme';
import Badge from '../atoms/Badge/BadgeTheme';
import ButtonSpinnerTheme from '../atoms/Button/ButtonSpinnerTheme';
import Button from '../atoms/Button/ButtonTheme';
import IconButton from '../atoms/Button/IconButtonTheme';
import Checkbox from '../atoms/Checkbox/CheckboxTheme';
import Skeleton from '../atoms/LoadingStates/Skeleton/SkeletonTheme';
import Spinner from '../atoms/LoadingStates/Spinner/SpinnerTheme';
import Radio from '../atoms/Radio/RadioTheme';
import Select from '../atoms/Select/SelectTheme';
import Switch from '../atoms/Switch/SwitchTheme';
import Tag from '../atoms/Tag/TagTheme';
import Tooltip from '../atoms/Tooltip/TooltipTheme';
import AvatarCustomTheme from '../molecules/AvatarGroup/AvatarGroupTheme';
import ButtonGroup from '../molecules/ButtonGroup/ButtonGroupTheme';
import Card from '../molecules/Card/CardTheme';
import FormError from '../molecules/FormControl/FormErrorTheme';
import FormLabel from '../molecules/FormControl/FormLabelTheme';
import Input from '../molecules/Input/InputTheme';
import Menu from '../molecules/Menu/MenuTheme';
import Modal from '../molecules/Modal/ModalTheme';
import PageHeaderTheme from '../molecules/PageHeader/PageHeaderTheme';
import Popover from '../molecules/Popover/PopoverTheme';
import Table from '../molecules/Table/TableTheme';
import Tabs from '../molecules/Tabs/TabsTheme';
import Toolbar from '../molecules/Toolbar/ToolbarTheme';
import SideBar from '../templates/SideBar/SideBarTheme';

/*
  ? NOTE: Instead of extending and overriding chakra components,
  ? these are custom built themes that can be used via `useStyleConfig` or `useMultiStyleConfig` hooks.
*/

const customThemedComponents = {
  AvatarCustomTheme,
  ButtonSpinnerTheme,
  Card,
  PageHeaderTheme,
  SideBar
};

const COMPONENTS = {
  Avatar,
  Badge,
  Button,
  ButtonGroup,
  Checkbox,
  FormError,
  FormLabel,
  IconButton,
  Input,
  Menu,
  Modal,
  Popover,
  Radio,
  Skeleton,
  Select,
  Spinner,
  Switch,
  Table,
  Tabs,
  Tag,
  Toolbar,
  Tooltip,
  ...customThemedComponents
};

export default COMPONENTS;
